import React, { useId } from "react"
import clsx from "clsx"
import { useField } from "formik"

type Option = {
  label: string
  value: string
}

type Props = {
  label?: React.ReactNode
  name: string
  options: Option[]
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const RadioButtons = ({ label, options, onChange, ...props }: Props) => {
  const [field, meta] = useField(props.name)
  const id = useId()

  return (
    <div>
      {label && (
        <div>
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label>{label}</label>
        </div>
      )}
      <div className="btn-group btn-group-toggle d-block">
        {options.map((option) => (
          <React.Fragment key={option.value}>
            <label
              className={clsx("btn btn-outline-primary w-50", {
                active: option.value === field.value,
              })}
              htmlFor={`${id}-${option.value}`}
            >
              <input
                type="radio"
                name={props.name}
                id={`${id}-${option.value}`}
                value={option.value}
                checked={option.value === field.value}
                onChange={(e) => {
                  field.onChange(e)
                  onChange?.(e)
                }}
              />
              {option.label}
            </label>
          </React.Fragment>
        ))}
      </div>
      {meta.touched && meta.error && (
        <div className="invalid-feedback d-block">{meta.error}</div>
      )}
    </div>
  )
}

export default RadioButtons
